import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { App } from 'pages';
import { store } from 'store';
import { theme } from './theme';
import './fontFaces.css';
import './style.css';

const CanvasApp = (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

const target = document.querySelector('#root');
const root = ReactDOM.createRoot(target);

root.render(CanvasApp);